<template>
  <div class="ctrl-100 ctrl">
    <el-button
      class="ctrl-btn"
      :class="{ active: createPollVisible }"
      @click="toggleVisibility"
      type="text"
    >
      <IconBase
        class="ctrl-icon"
        :height="32"
        :width="32"
        :view-box="`0 0 32 32`"
        :fill="'#E7E6FA'"
      >
        <IconPoll />
      </IconBase>
      Quick Poll
    </el-button>

    <div
      class="ctrl-window__overlay"
      v-if="createPollVisible"
      @click="createPollVisible = false"
    ></div>
    <transition name="fade">
      <div class="ctrl-window" v-if="createPollVisible" width="30%">
        <div class="ctrl__header">
          <h3 class="ctrl__title">Start a quick poll</h3>
          <div @click="createPollVisible = false">
            <IconBase
              :height="24"
              :width="24"
              :view-box="`0 0 24 24`"
              :fill="'#E7E6FA'"
            >
              <IconCross />
            </IconBase>
          </div>
        </div>
        <div lang="en">
          <el-form
            @submit.prevent.native="createPoll"
            :model="pollMessage"
            class="ctrl__form"
          >
            <div class="poll-radio-button">
              <el-radio-group v-model="pollMessage.postType">
                <el-radio label="This Room"></el-radio>
                <el-radio label="All Rooms"></el-radio>
              </el-radio-group>
            </div>
            <el-row>
              <el-input
                v-model="pollMessage.message"
                size="small"
                placeholder="Ask your question"
              ></el-input>
            </el-row>
          </el-form>
        </div>
        <span slot="footer" class="ctrl__footer">
          <el-button @click="cancelPoll">Cancel</el-button>
          <el-button type="primary" @click="createPoll">Post</el-button>
        </span>
      </div>
    </transition>
  </div>
</template>

<script>
import IconBase from "../IconBase";
import IconPoll from "../icons/IconPoll";
import IconCross from "../icons/IconCross";

import { mapState, mapGetters } from "vuex";
import { getSocketPayload , JITSI_CONSTANTS} from "../../utils";

export default {
  name: "ThumbsVote",
  components: {
    IconBase,
    IconPoll,
    IconCross
  },

  data: function() {
    return {
      createPollVisible: false,
      pollMessage: {
        message: "",
        postType: "This Room"
      }
    };
  },

  methods: {
    toggleVisibility() {
      this.createPollVisible = !this.createPollVisible;
    },
    createPoll() {
      this.socket.emit(
        "CREATE_POLL",
        getSocketPayload({
          event: this.mainRoom._id + "POLL",
          mainRoom: this.mainRoom.name,
          token: this.tokens ? this.tokens["idToken"] : null,
          message: this.pollMessage.message,
          pollType: this.pollMessage.postType,
          userName: this.name || JITSI_CONSTANTS.defaultDisplayName
        })
      );
      this.pollMessage.message = "";
      this.createPollVisible = false;
    },
    cancelPoll() {
      this.pollMessage.message = "";
      this.createPollVisible = false;
    }
  },
  computed: {
    ...mapState({
      name: state => state.rooms.name,
      mainRoom: state => state.rooms.mainRoom,
      currentRoom: state => state.rooms.currentRoom,
      tokens: state => state.user.tokens
    }),
    ...mapGetters("rooms", {
      socket: "getSocket"
    })
  }
};
</script>

<style scoped>
.poll {
  fill: #f7f7f7;
}

.poll:hover,
.poll-active {
  fill: #409eff;
}

.poll-visible {
  top: -80px;
  left: 700px;
  width: 1100px;
}

.poll-radio-button {
  padding-bottom: 10px;
}
.ctrl-icon {
  display: block;
}
>>> .el-radio {
  color: #e7e6fa;
}
>>> .el-radio__input.is-checked + .el-radio__label {
  color: #50c6df !important;
}
>>> .el-radio__input.is-checked .el-radio__inner {
  border-color: #50c6df;
  background: #50c6df;
}
</style>
